import { Component } from '@angular/core';

@Component({
  selector: 'casa-doc-not-found',
  standalone: true,
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {}
